<template>
  <div :class="classCustom ?? ''">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="onAcceptConfirmation()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="onDenyConfirmation()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-if="currentMissionModal" v-model="currentMissionModal" width="1008" persistent>
      <edit115-mission-component type="fromNewCall" :missionPhoneId="missionPhoneId" :missionId="missionId"
        :phoneId="phoneId" :callerId="callerId ? callerId : null"
        :uniqueId_NewCall="uniqueId"></edit115-mission-component>
    </v-dialog>
    <v-dialog width="550" v-model="endDNDNoteModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">توضیحات</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="cancleDNDNoteModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" class="mt-1 mr-1">
              <v-textarea dense rows="5" outlined label="علت" clearable class="sugest-input"
                clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-note mdi-18px"
                v-model="endDNDNote"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn rounded color="darkColor" dark @click="setFinishDND()" class="normal-letter-spacing px-10 ml-4">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancleDNDNoteModal()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="550" v-model="suggestCodeModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">ارجاع به 800</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="cancleSuggestCodeModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters class="mt-4">
            <v-col cols="12">
              <app-title-header title="کدهای پیشنهادی" />
            </v-col>
          </v-row>
          <v-container fluid class="py-2 main-bg">
            <v-row no-gutters>
              <v-col cols="6">
                <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="کد پیشنهادی" return-object clearable class="sugest-input"
                  clear-icon="mdi-close-circle-outline" autocomplete="off" prepend-inner-icon="mdi-medication mdi-18px"
                  v-model="selectedVehicleType"></v-autocomplete>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <v-text-field dense outlined @keypress="isNumber($event)" label="تعداد" class="sugest-input"
                  prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                  v-model="selectedVehicleTypeCount" @keydown.enter="addCodeForMission()"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="1" class="mt-1">
                <v-btn color="darkColor" elevation="0" block @click="addCodeForMission()">
                  <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row v-if="listOfSelectedCodes?.length > 0" class="mr-1 mt-n5 py-3">
              <span v-for="item in listOfSelectedCodes" :key="item.id" class="selectedCode mr-2 mt-1">
                {{ item.title }} ( {{ item.count }} )
                <v-icon @click="removeCodeFromMission(item.id)" class="mr-2">
                  mdi-close mdi-18px
                </v-icon>
              </span>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row no-gutters class="">
              <v-col cols="12" class="pr-0">
                <app-title-header title="سایر اطلاعات" />
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-4">
              <v-col cols="5">
                <v-text-field hide-details type="number" dense outlined prepend-inner-icon="mdi-numeric mdi-18px"
                  clearable clear-icon="mdi-close-circle-outline" v-model="numberOfPatients">
                  <template v-slot:label>
                    <span class="custom-label">تعداد مصدوم</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6">
                <v-autocomplete hide-details :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد" dense
                  item-text="title" outlined placeholder="اولویت" item-value="id" v-model="missionRank">
                  <template v-slot:prepend-inner>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" :color="rankIconColor" :class="rankIconClass">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </template>
                      {{ rankToolTip }}
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-cols cols="12">
                <v-checkbox v-if="doesTechnicianRequestPaitentLocation" hide-details :disabled="true"
                  v-model="doesTechnicianRequestPaitentLocation"
                  label="پیامک تایید موقعیت به مددجو ارسال شود"></v-checkbox>
                <v-checkbox v-else hide-details v-model="sendLocationSMS"
                  label="پیامک تایید موقعیت به مددجو ارسال شود"></v-checkbox>
              </v-cols>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn rounded color="darkColor" dark @click="sendTo800FromSuggestModal()"
              class="normal-letter-spacing px-10 ml-4">
              <div class="d-flex flex-column align-center">
                <span class="fontFamilySET" style="font-size: 14px; line-height: 1">ارجاع (F9)</span>
                <!-- <span style="font-size: 9px; margin-top: 4px; line-height: 1">Shift+Enter</span> -->
              </div>
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancleSuggestCodeModal()"
              class="normal-letter-spacing px-10">
              بستن
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="800" v-model="triageBaliniModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">راهنمایی/توصیه</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="cancleTriageBaliniModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12" v-for="item in compliantClinicalTriageList" :key="item.id">
              <v-checkbox style="text-align: start" :label="item.note" :disabled="item.isDisable" hide-details
                v-model="item.isSelected" @click="setClinicalTriageFor115MisssionFunction(item.id)"></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="compliantClinicalTriageList.length == 0">
            <v-spacer></v-spacer>
            <span class="mt-5">اطلاعاتی جهت نمایش وجود ندارد</span>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn rounded color="darkColor" outlined @click="cancleTriageBaliniModal()"
              class="normal-letter-spacing px-10">
              بستن
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isMissionRankModalOpen" width="350">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5 pb-8">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">تعیین اولویت</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="mt-3">
              <v-autocomplete :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد" dense item-text="title"
                placeholder="اولویت" item-value="id" v-model="missionRank">
                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" :color="rankIconColor" :class="rankIconClass">
                        mdi-car-emergency mdi-18px
                      </v-icon>
                    </template>
                    {{ rankToolTip }}
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" dark rounded :disabled="missionRank === null" @click="onMissionRankSetAccept()"
              class="normal-letter-spacing px-12 ml-5">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="closeMissionRankModal()"
              class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="attachmentModal" width="85%">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">{{ attachmentModalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="کد" rounded outlined dense v-model="searchTextCode_Attach"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="جستجو..." rounded outlined dense v-model="searchTextAttachment"></v-text-field>
            </v-col>
            <v-col cols="12">
              <template>
                <v-data-table :headers="attachmentCurrentMissionListHeader" :items="attachallFilterList"
                  :items-per-page="attachallFilterList.length" height="45vh" :search="searchTextAttachment"
                  :hide-default-footer="true" multi-sort class="elevation-0" @click:row="attachmentTableClick">
                  <template v-slot:[`item.check`]="{ item }">
                    <v-checkbox class="ma-0" v-model="item.check" @click="attachmentTableClick(item)"
                      hide-details></v-checkbox>
                  </template>
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" @click="endCallFunction('main', null, mainMissionId, uniqueId)" dark rounded
              class="normal-letter-spacing px-12 ml-5">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancelAttachment()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="100%" v-model="isAttachmentModalOpen">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-col cols="3" class="flex justify-end">
                <span class="modal-title-text">پیوست ها</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="1" class="flex justify-center">
                <v-btn x-small icon color="darkColor" @click="closeAttachmentModal">
                  <v-icon>mdi-close mdi-24px</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="10">
              <app-box outlined max-height="70vh" class="mx-auto">
                <v-img :src="selectedTriageImgSrc" max-height="900" max-width="100%"></v-img>
              </app-box>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2">
              <app-box max-height="70vh" outlined class="flex flex-col gap-4">
                <v-col v-for="{ id, filePath } in allAttachments" :key="id" class="img-box">
                  <v-img :src="filePath" :lazy-src="`https://picsum.photos/10/6?image=${id * 5 + 10}`" aspect-ratio="1"
                    max-width="100%" max-height="100%" @click="selectTriageImg(filePath)">
                    <div v-if="isSelectedTriageImg(filePath)" class="fill-height selected-img"></div>
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
              </app-box>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card height="675px" max-height="92vh" style="overflow: hidden">
      <section class="ch-100 cw-100">
        <header class="d-flex cw-100 align-center justify-center pa-0">
          <v-btn-toggle class="d-flex cw-50 align-center justify-center" mandatory v-model="currentSection">
            <v-btn height="36" depressed block class="rounded-t-0"
              :class="currentSection === 0 ? 'active-button' : 'btn'">
              تریاژ (F3)
            </v-btn>
            <v-btn height="36" depressed block class="rounded-t-0"
              :class="currentSection === 1 ? 'active-button' : 'btn'">
              اطلاعات اصلی (F2)
            </v-btn>
          </v-btn-toggle>
        </header>
        <Transition name="slide-fade">
          <!-- // تریاژ -->
          <section v-if="currentSection === 0"
            class="pb-4 cw-100 d-flex flex-column justify-start align-start boxMainContent">
            <v-row class="triage_container cw-100 ch-100">
              <v-col cols="6" class="ch-100 pl-2">
                <v-row no-gutters style="row-gap: 16px">
                  <v-col cols="6" class="pl-2">
                    <v-menu v-model="menuOpen_AllByCc" bottom offset-y :close-on-content-click="true" :max-height="220"
                      transition="slide-y-transition" :open-delay="100" :close-delay="100" z-index="10000"
                      content-class="searchMenu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :autofocus="selectItemFormList" dense outlined label="شکایت اصلی*" clearable
                          clear-icon="mdi-close-circle-outline" autocomplete="nope"
                          prepend-inner-icon="mdi-file-document mdi-18px" v-model="selectedChiefComplaint" hide-details
                          :loading="isLoading_AllByCc" @input="onSearchInput_AllByCc" @focus="
                            list_AllByCc?.length > 0
                              ? (menuOpen_AllByCc = true)
                              : (menuOpen_AllByCc = false)
                            " @click:clear="clearSearch" v-bind="attrs" v-on="on">
                          <template v-slot:label>
                            <span class="custom-label">شکایت اصلی*</span>
                          </template>
                        </v-text-field>
                      </template>
                      <v-card outlined class="searchMenuCard" elevation="2" v-if="list_AllByCc?.length > 0">
                        <div class="v-label theme--light menu-label">تشخیص های مرتبط</div>

                        <v-list class="pa-0 search-list cw-100" style="max-height: 200px; overflow-y: auto">
                          <v-list-item v-if="isLoading_AllByCc" class="justify-center py-4">
                            <v-progress-circular indeterminate size="24" color="primary"></v-progress-circular>
                          </v-list-item>
                          <v-list-item v-for="(item, index) in list_AllByCc" v-else :key="index"
                            class="location-list-item" @click="selectItem_AllByCc(item)">
                            <v-list-item-content>
                              <v-list-item-title class="location-title">
                                {{ item?.title ?? '' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete :items="allChiefComplaintsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                      color="primary" outlined item-text="title" item-value="id" label="تشخیص احتمالی پرستار*"
                      return-object hide-details v-model="currentNurseDiagnos" @change="onChiefComplaintChange"
                      clear-icon="mdi-close-circle-outline" autocomplete="nope">
                      <template v-slot:label>
                        <span class="custom-label">تشخیص احتمالی پرستار*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col :cols="type !== 'hand' ? '7' : '8'" class="pl-2">
                    <v-text-field dense outlined label="توضیح شکایت" prepend-inner-icon="mdi-text mdi-18px" clearable
                      clear-icon="mdi-close-circle-outline" v-model="complaintNote" hide-details>
                      <template v-slot:label>
                        <span class="custom-label">توضیح شکایت</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="2" class="pl-2">
                    <v-text-field hide-details type="number" dense outlined prepend-inner-icon="mdi-numeric mdi-18px"
                      clearable clear-icon="mdi-close-circle-outline" v-model="numberOfPatients">
                      <template v-slot:label>
                        <span class="custom-label">تعداد مصدوم</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete dense outlined :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد"
                      item-text="title" placeholder="اولویت" item-value="id" v-model="missionRank" label="اولویت"
                      clear-icon="mdi-close-circle-outline" hide-details>
                      <template v-slot:prepend-inner>
                        <v-icon :color="rankIconColor" class="" style="height: 24px">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </template>
                      <template v-slot:label>
                        <span class="custom-label">اولویت</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="1" v-if="type !== 'hand'">
                    <div class="d-flex-none mr-auto white rounded-circle customShadow custombtn" style="padding: 5px"
                      :class="{ hasBTS: callLocation == null }">
                      <v-tooltip v-if="callLocation?.isSuccessful" top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small icon dark rounded color="darkColor" @click="showBTSLocation">
                            <v-icon color="#1EAA6E" v-bind="attrs" v-on="on">
                              mdi-cellphone-marker mdi-16px
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>موقعیت BTS</span>
                      </v-tooltip>
                      <v-tooltip v-else top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon dark small rounded color="darkColor" :loading="gettingCallLocation"
                            @click="getCallLocation(uniqueId)">
                            <v-icon color="darkColor" v-bind="attrs" v-on="on">
                              mdi-selection-marker mdi-16px
                            </v-icon>
                          </v-btn>
                        </template>
                        <span> (F8) {{ ' ' }} استعلام موقعیت BTS</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
                <triage-box title="پرسش کلیدی" :has-data="allActiveQuestionsList?.length > 0" no-data-title="پرسشی"
                  class="triage_container-questions mt-6" style="height: calc(100px - 100px)">
                  <template>
                    <v-col v-if="allActiveQuestionsList?.length > 0" class="pt-0">
                      <div v-for="(question, index) in allActiveQuestionsList" :key="question?.id">
                        <v-checkbox hide-details v-model="selectedQuestions" :value="question" class="my-2">
                          <template v-slot:label>
                            <div class="flex items-baseline flex-wrap black--text">
                              <div class="">
                                <p class="text-right mb-0">
                                  {{ index + 1 }}. {{ question?.title }}
                                </p>
                              </div>
                              <v-btn text depressed small height="19px" plain
                                class="flex-grow justify-start items-start pr-0" color="#943a2d"
                                v-if="question?.otherChiefComplaintText"
                                @click="addNestedNurseDiagnos(question?.otherChiefComplaint)">
                                ({{ question?.otherChiefComplaintText }})
                              </v-btn>
                            </div>
                          </template>
                        </v-checkbox>
                        <v-divider />
                      </div>
                    </v-col>
                  </template>
                </triage-box>
              </v-col>
              <v-col cols="6" class="ch-100 pr-2">
                <div v-if="selectedNurseDiagnoses?.length == 0" class="triage_container-empty_algorithem-container">
                  <span></span>
                  <p>بدون الگوریتم ها تشخیص احتمالی پرستار</p>
                  <span></span>
                </div>
                <v-row v-else class="ma-0">
                  <div class="pl-0 triage_algorithemList">
                    <v-chip-group class="triage_container-chips_container"
                      active-class="triage_container-chips_container-active_chip" v-model="currentNurseDiagnosId">
                      <div v-for="({ title, id }, index) in selectedNurseDiagnoses" :key="id"
                        class="triage_chip_Selectitem">
                        <v-chip link class="triage_container-chips_container-chip_item ma-0"
                          @click="selectFromCurrentNurseDiagnoses(id)">
                          {{ title }}
                        </v-chip>
                        <!-- <div
                          class="divider"
                          v-if="index + 1 < selectedNurseDiagnoses?.length"
                        ></div> -->
                        <v-icon color="var(--v-primary-lighten3)" class="mt-1"
                          v-if="index + 1 < selectedNurseDiagnoses?.length">
                          mdi-ray-end-arrow
                        </v-icon>
                      </div>
                    </v-chip-group>
                  </div>
                  <div class="flex items-center justify-center">
                    <v-btn v-if="allAttachments?.length > 0" icon dark color="darkColor" @click="openAttachmentModal"
                      class="btnAttachment" small>
                      <v-icon size="16px">mdi-attachment</v-icon>
                    </v-btn>
                  </div>
                </v-row>
                <triage-box class="triage_container-answers rounded-lg" :class="{
                  'mt-4': selectedNurseDiagnoses?.length,
                  'mt-6': !selectedNurseDiagnoses?.length,
                }" title="سطوح اولویت اعزام" :has-data="allActiveAnswersList?.length > 0" no-data-title="پاسخی"
                  style="height: calc(100px - 76px)">
                  <template>
                    <v-col cols="12" class="triage_container-answers-body">
                      <div v-for="({ color, rank }, index) in answerRanks" :key="index"
                        class="triage_container-answers-body-item">
                        <v-card v-if="haveShownRank(rank)" elevation="0" :color="color"
                          style="border-radius: 12px !important">
                          <v-card-text class="py-2">
                            <div v-for="answer in allActiveAnswersList" :key="answer?.id">
                              <div v-if="answer.rank === rank">
                                <v-checkbox hide-details v-model="selectedAnswers" :value="answer" class="my-2">
                                  <template v-slot:label>
                                    <div class="black--text">
                                      <p class="mb-0 text-right">
                                        {{ answer?.title }}
                                      </p>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </v-col>
                  </template>
                </triage-box>
              </v-col>
            </v-row>
            <v-row no-gutters class="cw-100">
              <v-col class="px-3 cw-100">
                <triage-box v-if="selectedAnswers?.length > 0" title="پاسخ ها"
                  class="triage_answers_container relative cw-100">
                  <template>
                    <v-col cols="12" class="pt-0">
                      <div>
                        <v-chip-group column>
                          <answer-chip :disabledToolTip="true" v-for="(item, index) in selectedAnswers" :key="index"
                            v-bind="item" />
                        </v-chip-group>
                      </div>
                    </v-col>
                  </template>
                </triage-box>
              </v-col>
            </v-row>
          </section>
          <!-- // تریاژ -->
          <!-- //مشخصات اصلی -->
          <section class="cw-100 d-flex flex-column justify-start align-start boxMainContent">
            <div no-gutters class="midele">
              <v-row class="ch-100" style="margin-block: 0;max-width: 100%;">
                <v-col cols="7 pr-1" style="max-height: 100%; overflow-y: auto">
                  <div no-gutters class="topTitleBox">
                    <v-divider class="divider"></v-divider>
                    <div class="flexNone txt2_style">اطلاعات اصلی</div>
                    <div class="flexNone mr-auto">
                      <v-chip dark small :class="handleColorPassedTime(showPassedTime)">
                        <app-conversation questionClass="text-caption mr-2" question="مدت زمان تکمیل فرم">
                          <template v-slot:answer>
                            <div class="txt1_style">
                              {{ showPassedTime }}
                            </div>
                          </template>
                        </app-conversation>
                      </v-chip>
                    </div>
                    <div class="flexNone">
                      <v-chip small dark color="darkColor">
                        <app-conversation questionClass="text-caption mr-2" answerClass="text-caption ml-2"
                          question="تلفن اصلی" :answer="callerId ? callerId : '-'"></app-conversation>
                      </v-chip>
                    </div>
                  </div>
                  <v-row class="mt-2 mx-1 mainBoxItem">
                    <v-col cols="3">
                      <v-autocomplete autofocus :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" clearable clear-icon="mdi-close-circle-outline"
                        autocomplete="nope" prepend-inner-icon="mdi-home-city mdi-18px" return-object
                        v-model="selectedCity" :error="!!formErrors['city']" :error-messages="formErrors['city']"
                        :hide-details="!formErrors['city']" @change="handleErrorComplaintInput('city')">
                        <template v-slot:label>
                          <span class="custom-label">شهر*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="9" class="">
                      <v-text-field dense outlined prepend-inner-icon="mdi-map-marker mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="complaintAddress"
                        :error="!!formErrors['address']" :error-messages="formErrors['address']"
                        :hide-details="!formErrors['address']" @input="handleErrorComplaintInput('address')">
                        <template v-slot:label>
                          <span class="custom-label">آدرس محل فوریت*</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field dense outlined clearable clear-icon="mdi-close-circle-outline" autocomplete="nope"
                        prepend-inner-icon="mdi-file-document mdi-18px" v-model="selectedChiefComplaint"
                        :error="!!formErrors['chiefComplaint']" :error-messages="formErrors['chiefComplaint']"
                        :hide-details="!formErrors['chiefComplaint']"
                        @input="handleErrorComplaintInput('chiefComplaint')">
                        <template v-slot:label>
                          <span class="custom-label">شکایت اصلی*</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <!-- <v-autocomplete :items="allChiefComplaintsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" clearable return-object
                        @change="chiefComplaintChange" v-model="selectedNurseDesition"
                        clear-icon="mdi-close-circle-outline" autocomplete="nope"
                        prepend-inner-icon="mdi-file-document mdi-18px" :error="!!formErrors['nurseDesition']"
                        :error-messages="formErrors['nurseDesition']" :hide-details="!formErrors['nurseDesition']">
                        <template v-slot:label>
                          <span class="custom-label">تشخیص احتمالی پرستار*</span>
                        </template>
                      </v-autocomplete> -->

                      <v-autocomplete :items="allChiefComplaintsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                        color="primary" outlined item-text="title" item-value="id" label="تشخیص احتمالی پرستار*"
                        return-object v-model="currentNurseDiagnos" @change="onChiefComplaintChange"
                        clear-icon="mdi-close-circle-outline" autocomplete="nope"
                        prepend-inner-icon="mdi-file-document mdi-18px" :error="!!formErrors['nurseDesition']"
                        :error-messages="formErrors['nurseDesition']" :hide-details="!formErrors['nurseDesition']">
                        <template v-slot:label>
                          <span class="custom-label">تشخیص احتمالی پرستار*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field dense outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="complaintNote" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">توضیح شکایت</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="3">
                      <v-autocomplete dense outlined :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد"
                        item-text="title" placeholder="اولویت" item-value="id" v-model="missionRank"
                        clear-icon="mdi-close-circle-outline" :error="!!formErrors['missionRank']"
                        :error-messages="formErrors['missionRank']" :hide-details="!formErrors['missionRank']"
                        @change="handleErrorComplaintInput('missionRank')">
                        <template v-slot:prepend-inner>
                          <v-icon :color="rankIconColor" class="" style="height: 24px">
                            mdi-car-emergency mdi-18px
                          </v-icon>
                        </template>
                        <template v-slot:label>
                          <span class="custom-label">اولویت*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete hide-details :items="missionInformTypeItems" no-data-text="اطلاعاتی وجود ندارد"
                        dense outlined item-text="title" item-value="id" label="نوع درخواست" clearable
                        clear-icon="mdi-close-circle-outline" autocomplete="off"
                        prepend-inner-icon="mdi-car-emergency mdi-18px" v-model="missionInformTypeId"></v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field dense @keypress="isNumberWithSpace($event)" outlined
                        prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="compliantRecoveryPhone"
                        :error="!!formErrors['phone']" :error-messages="formErrors['phone']"
                        :hide-details="!formErrors['phone']" @input="handleErrorComplaintInput('phone')">
                        <template v-slot:label>
                          <span class="custom-label">تلفن پیگیری</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-autocomplete :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                        item-text="title" item-value="id" clearable clear-icon="mdi-close-circle-outline"
                        autocomplete="nope" chips multiple prepend-inner-icon="mdi-label mdi-flip-h mdi-18px"
                        v-model="compliantTag" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">برچسب ها</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-autocomplete :items="allOtherOrganizationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" clearable clear-icon="mdi-close-circle-outline"
                        autocomplete="nope" chips multiple prepend-inner-icon="mdi-car-emergency mdi-18px"
                        v-model="compliantOtherOrganizations" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">درخواست سازمان همکار</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-checkbox v-model="compliantHasDoctorConsultant" label="مشاوره پزشک" class="mt-1"
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12">
                      <div class="flex align-center justify-start" style="gap: 6px">
                        <div class="" style="max-width: 120px">
                          <v-text-field hide-details type="number" dense outlined
                            prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                            v-model="numberOfPatients">
                            <template v-slot:label>
                              <span class="custom-label">تعداد مصدوم</span>
                            </template>
                          </v-text-field>
                        </div>
                        <div class="" style="max-width: 160px">
                          <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" item-value="id" return-object clearable class="sugest-input"
                            clear-icon="mdi-close-circle-outline" autocomplete="off"
                            prepend-inner-icon="mdi-medication mdi-18px" v-model="selectedVehicleType" hide-details>
                            <template v-slot:label>
                              <span class="custom-label">کد پیشنهادی</span>
                            </template>
                          </v-autocomplete>
                        </div>
                        <div class="" style="max-width: 120px">
                          <v-text-field dense outlined class="sugest-input" prepend-inner-icon="mdi-numeric mdi-18px"
                            clearable clear-icon="mdi-close-circle-outline" v-model="selectedVehicleTypeCount"
                            hide-details @keydown.enter="addCodeForMission()">
                            <template v-slot:label>
                              <span class="custom-label">تعداد پیشنهادی</span>
                            </template>
                          </v-text-field>
                        </div>
                        <div class="d-flex justify-center align-center">
                          <button class="darkColor btnAddCodeForMission" @click="addCodeForMission()">
                            <v-icon color="white" size="18px">mdi-plus</v-icon>
                          </button>
                        </div>
                        <div class="selectCodeBox">
                          <span v-for="item in listOfSelectedCodes" :key="item.id" class="selectedCode mr-2 mt-1 mb-1">
                            {{ item.title }} ( {{ item.count }} )
                            <v-icon @click="removeCodeFromMission(item.id)" class="mr-2">
                              mdi-close mdi-18px
                            </v-icon>
                          </span>
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="general-triage-map-part cw-100"
                      style="padding-top: 0 !important; padding-bottom: 0 !important">
                      <div class="d-flex items-center justify-start pr-2 flex-gap-2 cw-100">
                        <div class="d-flex items-center">
                          <div class="general-triage-title">روند:</div>
                        </div>
                        <div class="pl-0 cw-100 overflow-x-auto" ref="chipScrollContainer">
                          <v-chip-group class="triage_container-chips_container">
                            <div v-for="({ title, id }, index) in selectedNurseDiagnoses" :key="id"
                              class="triage_chip_Selectitem">
                              <v-chip class="triage_container-chips_container-chip_item ma-0" :autofocus="index + 1 == selectedNurseDiagnoses.length ? true : false
                                " style="font-size: 11px !important; height: 24px !important" :class="index + 1 == selectedNurseDiagnoses.length
                                  ? 'triage_container-chips_container-active_chip'
                                  : ''
                                  ">
                                {{ title }}
                              </v-chip>

                              <!-- <span
                                class="divider"
                                v-if="index + 1 < selectedNurseDiagnoses.length"
                              ></span> -->
                              <v-icon color="var(--v-primary-lighten3)" class="mt-1"
                                v-if="index + 1 < selectedNurseDiagnoses?.length">
                                mdi-ray-end-arrow
                              </v-icon>
                            </div>
                          </v-chip-group>
                        </div>
                      </div>
                      <v-row v-if="lastGeneralTriageHint != '' && lastGeneralTriageHint != '-'">
                        <v-spacer></v-spacer>
                        <v-col cols="11" class="mt-4">
                          <v-divider></v-divider>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mb-2 mr-1 items-center"
                        v-if="lastGeneralTriageHint != '' && lastGeneralTriageHint != '-'">
                        <v-col class="pr-2 triage-advice-title-part">
                          <span class="general-triage-title">توصیه:</span>
                        </v-col>
                        <v-col class="triage-advice-text-part">
                          <span>{{ lastGeneralTriageHint }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="general-triage-map-part cw-100 mt-1"
                      style="padding-top: 0 !important; padding-bottom: 0 !important">
                      <div class="d-flex items-center justify-start pr-2 flex-gap-2 cw-100">
                        <div class="d-flex items-center">
                          <div class="general-triage-title">پاسخ ها:</div>
                        </div>
                        <div class="pl-0 cw-100 overflow-y-auto" style="max-height: 60px; min-height: 32px">
                          <v-chip-group column>
                            <answer-chip :disabledToolTip="true" v-for="(item, index) in selectedAnswers" :key="index"
                              v-bind="item" :simple-color="true" :have-tooltip="false" fontText="10px"
                              heightChip="24px" />
                          </v-chip-group>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div no-gutters class="topTitleBox pa-0 ma-0">
                        <v-divider class="divider"></v-divider>
                        <div class="flexNone txt2_style">اطلاعات تکمیلی</div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field dense outlined prepend-inner-icon="mdi-account mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="patientFirstName" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">نام مددجو</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field dense outlined prepend-inner-icon="mdi-account mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="patientLastName" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">نام خانوادگی مددجو</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-autocomplete :items="gender115Items" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                        item-text="title" item-value="id" clearable clear-icon="mdi-close-circle-outline"
                        autocomplete="off" prepend-inner-icon="mdi-human-male-female mdi-18px" v-model="patientGender"
                        hide-details>
                        <template v-slot:label>
                          <span class="custom-label">جنسیت</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-text-field dense @keypress="isNumber($event)" outlined maxlength="10"
                        prepend-inner-icon="mdi-card-account-details mdi-18px" clearable
                        clear-icon="mdi-close-circle-outline" v-model="patientNationalCode" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">کد ملی مددجو</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="">
                      <div class="flex align-center justify-start" style="gap: 6px">
                        <div class="ml-1">
                          <v-checkbox label="نوزاد" v-model="isPatientNewBorn" class="mt-0" hide-details />
                        </div>
                        <div>
                          <v-text-field @keypress="isNumber($event)" dense outlined maxlength="3"
                            prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                            :disabled="!isPatientNewBorn" v-model="patientAgeDay" hide-details>
                            <template v-slot:label>
                              <span class="custom-label">سن (روز)</span>
                            </template>
                          </v-text-field>
                        </div>
                        <div>
                          <v-text-field dense outlined maxlength="2" @keypress="isNumber($event)"
                            prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                            v-model="patientAgeMonth" hide-details>
                            <template v-slot:label>
                              <span class="custom-label">سن (ماه)</span>
                            </template>
                          </v-text-field>
                        </div>
                        <div>
                          <v-text-field @keypress="isNumber($event)" dense outlined maxlength="3"
                            prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                            v-model="patientAgeYear" hide-details>
                            <template v-slot:label>
                              <span class="custom-label">سن (سال)</span>
                            </template>
                          </v-text-field>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-autocomplete :items="patientRelationList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                        item-text="title" item-value="value" clearable clear-icon="mdi-close-circle-outline"
                        autocomplete="off" prepend-inner-icon="mdi-account-supervisor mdi-18px"
                        v-model="patientRelation" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">نسبت تماس گیرنده</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="">
                      <v-text-field dense @keypress="isNumber($event)" maxlength="10" outlined
                        prepend-inner-icon="mdi-map-marker mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                        v-model="compliantPostalCode" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">کدپستی</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" class="">
                      <v-text-field dense outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                        v-model="compliantMoreInformationNote" clear-icon="mdi-close-circle-outline" hide-details>
                        <template v-slot:label>
                          <span class="custom-label">توضیحات</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- //آدرس ها جاری -->
                <v-col cols="5" class="ch-100 pr-0" v-if="activeTabCustom == 1">
                  <v-row class="ch-100 ma-0">
                    <div class="cw-100 pl-3">
                      <v-text-field hide-details outlined rounded dense placeholder="جستجو ..." class="search-map-input"
                        clearable clear-icon="mdi-close-circle-outline" v-model="searchCurrentMission"></v-text-field>
                    </div>
                    <v-col cols="12" class="pr-0" style="height: calc(100% - 34px)">
                      <v-card elevation="0" class="current-missions-card ch-100" style="border-radius: 15px !important">
                        <v-data-table :headers="onlineMissionListHeader" :items="onlineMissionFilterList"
                          :items-per-page="onlineMissionFilterList.length" :hide-default-footer="true" multi-sort
                          fixed-header height="100%" class="elevation-0 current-mission current-mission-table ch-100"
                          @dblclick:row="onRowDblClick">
                          <template v-slot:[`item.phoneNumber`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <section v-on="on">
                                  <app-wrap-text :text="(item?.phoneNumber ?? '') + '' ?? ''" />
                                </section>
                              </template>
                              <span>{{ item?.phoneNumber }}</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.address`]="{ item }">
                            <p style="text-wrap: nowrap; white-space: nowrap" class="ma-0">
                              {{ item?.address }}
                            </p>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- //سوابق -->
                <v-col cols="5" class="ch-100 pr-0" v-if="activeTabCustom == 2">
                  <v-row class="ch-100 ma-0">
                    <v-col cols="12" class="pr-0 ch-100">
                      <v-card elevation="0" class="current-missions-card ch-100" style="border-radius: 15px !important">
                        <v-data-table :headers="callerHistoryInFormListHeader" :items="callerHistoryInFormList"
                          :items-per-page="callerHistoryInFormList.length" :hide-default-footer="true" multi-sort
                          fixed-header height="100%" class="elevation-0 current-mission current-mission-table ch-100">
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="showConfirmDialogOnSetHistoryInfo(item)" v-bind="attrs" v-on="on">
                                  mdi-map-marker
                                </v-icon>
                              </template>
                              <span>ثبت اطلاعات</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- //نقشه -->
                <v-col cols="5" class="pr-0" v-else-if="activeTabCustom == 0">
                  <div id="map" class="h-100 ml-3" style="height: 100%">
                    <app-leaflet-map searchable clickable draggable v-model="position" style="position: relative"
                      ref="leafletMapRef" :mapTitle="$store.state.SystemSettingModule.systemSetting?.mapTile ||
                        'https://memaps.ir/hot/{z}/{x}/{y}.png'" :center="currentCenter">
                      <template #btn_BTS v-if="type !== 'hand'">
                        <div class="d-flex-none mr-auto white rounded-circle customShadow" style="padding: 5px"
                          :class="{ hasBTS: callLocation == null }">
                          <v-tooltip v-if="callLocation?.isSuccessful" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small icon dark rounded color="darkColor" @click="showBTSLocation">
                                <v-icon color="#1EAA6E" v-bind="attrs" v-on="on">
                                  mdi-cellphone-marker mdi-16px
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>موقعیت BTS</span>
                          </v-tooltip>
                          <v-tooltip v-else top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon dark small rounded color="darkColor" :loading="gettingCallLocation"
                                @click="getCallLocation(uniqueId)">
                                <v-icon color="darkColor" v-bind="attrs" v-on="on">
                                  mdi-selection-marker mdi-16px
                                </v-icon>
                              </v-btn>
                            </template>
                            <span> (F8) {{ ' ' }} استعلام موقعیت BTS</span>
                          </v-tooltip>
                        </div>
                      </template>
                      <template #default-popup>
                        <map-address-popup :lat-lng="position">
                          <template #action="{ address }">
                            <div class="d-flex align-center justify-space-between flex-gap-2">
                              <v-checkbox dense hide-details v-model="acceptLocation" label="تایید موقعیت"
                                class="custom-checkbox-label mt-0 pt-0" />
                              <div class="fontFamilySET mx-auto text-center rounded" :class="[
                                'caption',
                                isLoading
                                  ? 'grey lighten-3 animate-pulse grey--text lighten-3'
                                  : '',
                              ]" style="
                                  text-wrap: nowrap;
                                  white-space: nowrap;
                                  font-family: Yekan-Bakh-Regular !important;
                                ">
                                lat :
                                {{ position?.lat?.toFixed(4) || '' }} &nbsp; - &nbsp; lng :
                                {{ position?.lng?.toFixed(4) || '' }}
                              </div>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon class="mt-0" @click="complaintAddress = address"
                                    style="height: 20px; width: 20px">
                                    <v-icon color="darkColor" size="20px">mdi-content-copy</v-icon>
                                  </v-btn>
                                </template>
                                <span>انتخاب آدرس</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" icon class="mt-0" @click="removeMarker"
                                    style="height: 20px; width: 20px">
                                    <v-icon color="#ff0000" size="20px">mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>حذف</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </map-address-popup>
                      </template>
                    </app-leaflet-map>
                  </div>
                </v-col>
              </v-row>

              <div class="boxTabSelect">
                <div class="absolute-wrapper">
                  <div class="rotated-wrapper tabBOX">
                    <v-tabs v-model="activeTabCustom"
                      class="v-slide-group v-tabs v-tabs--horizontal v-tabs--align-tabs-center v-tabs--density-default custom-v-tabs custom-tabs-with-divider">
                      <v-tab v-for="(item, index) in itemstabCustom" :key="item" class="tabCustom" color="darkColor"
                        :class="{ 'darkColor white--text': activeTabCustom === index }">
                        {{ item }}
                        <span v-if="item == 'سوابق'" class="counterSpan"
                          :class="{ hasNumber: callerHistoryInFormList.length > 0 }">
                          <span class="s1" style="font-family: Arial">
                            {{ callerHistoryInFormList.length ?? 56 }}
                          </span>
                        </span>
                      </v-tab>
                    </v-tabs>
                  </div>
                </div>
              </div>
            </div>

            <v-card elevation="7" class="new-call-footer rounded-t-3">
              <v-row no-gutters class="boxFooter">
                <v-col cols="6">
                  <div class="btnsFootr itemRightBtnsFootr">
                    <v-btn small rounded dark color="darkColor" elevation="0" class=""
                      @click="navigateTo('missionReport')">
                      گزارش پرونده
                    </v-btn>
                    <v-btn small rounded color="darkColor" elevation="0" dark class="" style="font-family: Arial"
                      v-if="!isMainDNDNewCall && hasDnd" @click="enableUserDNDsnFunction('home')">
                      DND
                    </v-btn>
                    <v-btn v-if="isMainDNDNewCall && hasDnd" small rounded dark color="darkColor" elevation="0" class=""
                      @click="showDNDNoteModal('home')" style="max-width: fit-content !important">
                      پایان DND
                      <span class="mr-2">({{ dndTimeNewCall }})</span>
                    </v-btn>
                    <v-btn small rounded dark color="darkColor" elevation="0" class="" @click="showTriageBaliniModal()">
                      توصیه و راهنما
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="6" class="mr-auto">
                  <div class="btnsFootr itemLeftBtnsFootr" style="justify-content: flex-end">
                    <div cols="4" v-if="!isFinalize">
                      <v-btn color="darkColor" dark rounded block @click="showSuggestCodeModal()"
                        class="normal-letter-spacing">
                        <div class="d-flex flex-column align-center">
                          <span class="fontFamilySET" style="font-size: 14px; line-height: 1">
                            ارجاع به 800 (F9)
                          </span>
                          <!-- <span style="font-size: 9px; margin-top: 4px; line-height: 1">
                            Shift+Enter
                          </span> -->
                        </div>
                      </v-btn>
                    </div>
                    <div cols="4">
                      <v-menu v-if="type !== 'hand' && !isFinalize && !$route.path?.includes('800')" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="darkColor" rounded block v-bind="attrs" v-on="on" outlined
                            class="normal-letter-spacing">
                            پایان تماس
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-for="(item, index) in endCallTagsList" :key="index"
                            @click="showConsultConfirmDialog(item.id, item.isAttachable)">
                            <v-list-item-title class="calltag-items">
                              {{ item.persianTitle }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-btn v-else-if="type === 'hand' && !isFinalize" @click="closeNewHandleForm()" rounded dense
                        outlined color="darkColor" block class="normal-letter-spacing">
                        انصراف
                      </v-btn>
                    </div>

                    <div cols="4" v-if="isFinalize">
                      <v-btn color="darkColor" rounded block
                        @click="checkForFinalizeMission(selectedQuestions, selectedAnswers)" outlined
                        class="normal-letter-spacing">
                        <div class="d-flex flex-column align-center">
                          <span class="fontFamilySET" style="font-size: 13px; line-height: 1">
                            ثبت و فعال سازی (F9)
                          </span>
                          <!-- <span style="font-size: 9px; margin-top: 4px; line-height: 1">
                            Shift+Enter
                          </span> -->
                        </div>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </section>
          <!-- //مشخصات اصلی -->
        </Transition>
      </section>
    </v-card>

    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import ShearedHelper from '@/Helpers/Shared.js';
import NewCallHelper from '@/Helpers/115/NewCallHelper.js';
import TriageHelper from '@/Helpers/115/NewCall/Triage.helper';

import { latLng } from 'leaflet';
import L from 'leaflet';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import cityMixin from '@/Mixins/BaseInformation/CityMixin';
import ServiceMixin from '@/Mixins/ServiceMixin';
import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import TagMixin from '@/Mixins/BaseInformation/TagMixin.js';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import GeneralTriageQuestionMixin from '@/Mixins/Triage/GeneralTriageQuestionMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import MissionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import TriageQuestionMixin from '@/Mixins/Triage/TriageQuestionMixin';
import MapMixin from '@/Mixins/115/MapMixin.js';
import ClinicalTriageMixin from '@/Mixins/BaseInformation/ClinicalTriageMixin.js';
import MissionPhoneMixin from '@/Mixins/Mission/MissionPhonesMixin.js';
import CallTagMixin from '@/Mixins/Call/CallTagMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin.js';
import UserDNDMixin from '@/Mixins/BaseInformation/UserDNDMixin.js';
import SharedMap from '@/Mixins/map';
import TriageMixin from '@/Mixins/115/NewCall/Triage.mixin';
import ChiefComplaintAttachmentMixin from '@/Mixins/BaseInformation/ChiefComplaint/attachment.mixin';

import AnswerChip from '@/components/BaseInformation/ChiefComplaint/Answer/TitleContainer.vue';
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppWrapText from '@/components/app/wrapText.vue';
import AppLeafletMap from '@/components/app/map/index.vue';
import MapAddressPopup from '@/components/app/map/address.popup.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import Edit115MissionComponent from '@/components/115/Edit115MissionComponent.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import TriageBox from '@/components/115/NewCall/Triage/box.vue';
import AppBox from '@/components/app/box.vue';
import AppConversation from '@/components/app/conversationNew.vue';

export default {
  name: 'NewCall',
  inject: ['load'],
  props: {
    uniqueId: {
      type: String,
      require: true,
    },
    callerId: {
      type: String,
      require: true,
    },
    destination: {
      type: String,
      require: true,
    },
    type: {
      type: String,
      require: true,
    },
    classCustom: {
      type: String,
      require: false,
      default: '',
    },
    selectItemFormList: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  components: {
    AlertComponent,
    // LMap,
    // LTileLayer,
    // LMarker,
    // LControl,
    Edit115MissionComponent,
    ConfirmDialog,
    AppTitleHeader,
    // Container,
    AnswerChip,
    AppWrapText,
    AppLeafletMap,
    MapAddressPopup,
    //
    TriageBox,
    AppBox,
    AppConversation,
  },
  mixins: [
    snackBar,
    ShearedMixin,
    cityMixin,
    ServiceMixin,
    ShearedHelper,
    ChiefComplaintMixin,
    TagMixin,
    VehicleTypeMixin,
    NewCallHelper,
    GeneralTriageQuestionMixin,
    MissionMixin,
    CallMixin,
    TriageQuestionMixin,
    MapMixin,
    ClinicalTriageMixin,
    MissionPhoneMixin,
    CallTagMixin,
    OtherOrganizationMixin,
    UserDNDMixin,
    TriageHelper,
    MissionStateMixin,
    SharedMap,
    //
    TriageMixin,
    ChiefComplaintAttachmentMixin,
  ],
  created() {
    this.$root.$refs[`newCallComponent_${this.uniqueId}`] = this;
    this.toggleTimer();
  },
  mounted() {
    this.mounte();
    window.addEventListener('keydown', this.handleFunctionKeys);
    this.clearTimer();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleFunctionKeys);
    clearInterval(this.rankIconInterval);
    clearInterval(this.passedTimeInterval);
    delete this.$root.$refs[`newCallComponent_${this.uniqueId}`];
    this.clearTimer();
  },
  unmounted() {
    this.clearTimer();
  },
  watch: {
    selectedChiefComplaint(newVal) {
      if (!newVal) {
        this.searchQuery_AllByCc = '';
      }
    },
    selectedNurseDesition: function (val) {
      if (val) {
        this.searchCurrentMission = val.title;
        this.getListOfClinicalTriagesForOther(val.id);
      }
    },
    missionRank: function (val) {
      if (val != null && val != undefined) {
        if (val === 0) {
          this.rankToolTip = 'عدم اعزام';
          this.rankIconColor = '#212121';
          this.rankAlarmAnimation = 1;
          this.rankIconClass = 'mt-1';
          if (this.rankIconInterval) {
            clearInterval(this.rankIconInterval);
          }
        } else if (val === 1) {
          this.rankToolTip = 'اعزام آمبولانس در صورت وجود کد';
          this.rankIconColor = '#3BCA79';
          this.rankAlarmAnimation = 1;
          this.rankIconClass = 'mt-1';
          clearInterval(this.rankIconInterval);
        } else if (val === 2) {
          this.rankToolTip = 'اعزام آمبولانس در صورت وجود کد';
          this.rankIconColor = '#F2BD27';
          this.rankAlarmAnimation = 1;
          //this.rankIconClass = "rank-icon-anim2 mt-1";
          this.rankIconClass = 'mt-1';
          clearInterval(this.rankIconInterval);
        } else if (val === 3) {
          this.showTostAlarm(); //نمایش آلارم

          this.rankToolTip = 'اعزام آمبولانس';
          //this.rankIconClass = "rank-icon-anim1 mt-1";
          this.rankIconClass = 'mt-1';
          this.rankIconInterval = setInterval(() => {
            this.rankAlarmAnimation++;
            if (this.rankAlarmAnimation % 2 === 0) {
              this.rankIconColor = '#D1D1D1';
            } else {
              this.rankIconColor = '#F56060';
            }
          }, 300);
        }
      }
    },
    currentSection(newVal) {
      if (newVal === 1 && this.callLocation && !this.btsShown) {
        this.btsShown = true;
        this.$nextTick(() => {
          this.showBTSLocation();
        });
      }
    },
    callLocation(newVal) {
      if (this.currentSection === 1 && newVal && !this.btsShown) {
        this.btsShown = true;
        this.$nextTick(() => {
          this.showBTSLocation();
        });
      }
    },
  },
  data() {
    return {
      btsShown: false,
      searchTextCode_Attach: '',
      currentMissionModal: false,
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      // currentCenter: latLng(30.2839, 57.0834),
      currentCenter: [30.2839, 57.0834],
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: null,
      dragging: false,
      icon: this.getIcon,
      selectedEndCallId: -1,
      selectedEndCallAttachable: false,
      pageTtile: '',
      activeTabCustom: 0,
      itemstabCustom: ['نقشه', 'آدرس جاری', 'سوابق'],
      //
      menuOpen_AllByCc: false,
      selectedChiefComplaint: '',
      searchQuery_AllByCc: '',
      list_AllByCc: [],
      isLoading_AllByCc: false,
      searchTimer_AllByCc: null,
    };
  },
  methods: {
    onRowDblClick(slot, item) {
      if (item?.item.isClickable === false) {
        return;
      }
      this.showEdit115MissionModal(slot, item);
    },
    removeMarker() {
      if (this.$refs.leafletMapRef) {
        this.$refs.leafletMapRef.removeMarker();
      }
    },
    onSearchInput_AllByCc(value) {
      this.clearTimer();
      this.searchQuery_AllByCc = value;
      if (!value) {
        this.menuOpen_AllByCc = true;
        this.list_AllByCc = [];
        return;
      }

      this.searchTimer_AllByCc = setTimeout(() => {
        if (this.searchQuery_AllByCc.trim().length > 2) {
          this.fetchAllByCc(value);
        }
      }, 700);
      if (this.searchQuery_AllByCc.trim().length == 0) {
        this.list_AllByCc = [];
      }
    },

    fetchAllByCc: function async(title) {
      this.isLoading_AllByCc = true;
      this.menuOpen_AllByCc = true;

      try {
        this.$store.dispatch('getAllByCcChiefComplaint', title).then(() => {
          if (this.$store.state.chiefComplaintModule.successFlag) {
            this.list_AllByCc = this.$store.state.chiefComplaintModule.allByCcChiefComplaints ?? [];
            this.isLoading_AllByCc = false;
          } else {
            this.isLoading_AllByCc = false;
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllByCcChiefComplaints(title);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllByCcChiefComplaints(title);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      } catch (error) {
        this.isLoading_AllByCc = false;
      }
    },

    selectItem_AllByCc(item) {
      this.onChiefComplaintChange(item);
      this.menuOpen_AllByCc = false;
    },

    clearSearch() {
      this.selectedChiefComplaint = '';
      this.searchQuery_AllByCc = '';
      this.list_AllByCc = [];
      this.menuOpen_AllByCc = false;
    },
    clearTimer() {
      if (this.searchTimer_AllByCc) {
        clearTimeout(this.searchTimer_AllByCc);
        this.searchTimer_AllByCc = null;
      }
    },
    handleErrorComplaintInput(value) {
      if (this.formErrors[value]) {
        delete this.formErrors[value];
      }
    },
    mounte: function () {
      this.formLoad = true;
      if (this.$root.$refs.Home.currentRoleId == 3) {
        this.hasDnd = true;
      }
      if (this.type == 'call') {
        this.missionCreationType = 0;
        this.missionType = 'تلفنی';
      } else if (this.type == 'hand') {
        this.missionCreationType = 1;
        this.missionType = 'دستی';
      } else {
        this.missionCreationType = null;
        this.missionType = '-';
      }
      L?.Icon?.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.missionInformTypeId = 1;
      this.setMapBaseSystemSetting();
      const map = this.$refs?.modalmap?.mapObject;
      map?.addControl(new window.L.Control.Fullscreen());
      this.mapInvalidate();
      this.getGeneralTriageQuestions();
      this.getListOfCallTagForMissionResultFunction(this.type);
      this.getListOfChiefComplaintsForOther();
      this.getListOfCitysForOther();
      this.getListOfOtherOrganizationsForOther();
      this.getAllCurrentMissionForFormFunction();

      this.getListOfVehicleTypesForOther();
      this.getListOfTagsForOther();
      this.initialPageTitle();
      if (this.callerId) {
        this.getAllCallerHistoryForMissionFunction(this.callerId);
      }
      this.checkDnd();
    },
    goToReportPage: function () {
      window.open(
        this.$router.resolve({ name: 'missionReport' }).href,
        '_blank',
        'noopener,noreferrer',
      );
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap?.mapObject?.invalidateSize();
      }, 100);
    },
    showBTSLocation: function () {
      if (this.callLocation?.isMobileLocation) {
        const latlng = {
          lat: this.callLocation?.latitude,
          lng: this.callLocation?.longitude,
        };
        if (this.$refs.leafletMapRef) {
          this.$refs.leafletMapRef.onSearchSuggestion(latlng);
          // const childData = this.$refs.leafletMapRef.defaultMarkerPosition
        }
      } else if (this.callLocation?.address) {
        this.complaintAddress = this.callLocation?.address ?? '';
      }
    },
    sendConsultCall() {
      this.endCallFunction('main', this.selectedEndCallId, this.mainMissionId, this.uniqueId);
    },
    checkEndCallType: function (id, attachable) {
      if (attachable) {
        this.showCurrentMissionAttachmentModal(this.selectedEndCallId);
        this.callTagId = Number(id);
      } else {
        this.callTagId = Number(id);
        this.mainMissionId = null;
      }
    },
    onConfirmModalConfirmation: function () { },
    showConfirmDialogOnSetHistoryInfo: function (data) {
      this.$refs.confirm.showConfirmDialog = true;
      this.$refs.confirm.title = 'ثبت اطلاعات';
      this.$refs.confirm.text = 'آیا از ثبت اطلاعات اطمینان دارید؟';
      this.confirmType = 1;
      this.historyData = data;
    },
    setModalTexts: function (id) {
      switch (id) {
        case 3:
          this.$refs.confirm.title = 'ثبت مزاحمت';
          this.$refs.confirm.text = 'آیا از ثبت مزاحمت اطمینان دارید؟';
          return true;
        case 6:
          this.$refs.confirm.title = 'ثبت سایر';
          this.$refs.confirm.text = 'آیا از ثبت نتیجه سایر اطمینان دارید؟';
          return true;
        default:
          return false;
      }
    },
    onAcceptConfirmation() {
      switch (this.confirmType) {
        case 0:
          this.sendConsultCall();
          break;
        case 1:
          this.setMissionInformationFromHistory(this.historyData);
          break;
        default:
          break;
      }
      this.$refs.confirm.showConfirmDialog = false;
    },
    onDenyConfirmation() {
      this.$refs.confirm.showConfirmDialog = false;
    },
    handleColorPassedTime(time) {
      if (!time) return 'darkColor';

      let duration = time.split(':');
      let calculatedDuration = Number(duration[0] * 60) + Number(duration[1]);

      if (calculatedDuration > 180) {
        return 'red darken-4';
      }
      if (calculatedDuration > 90) {
        return 'yellow darken-2';
      }
      return 'darkColor';
    },
    // handle F Keys
    handleFunctionKeys(e) {
      const keyActions = {
        F3: () => (this.currentSection = 0),
        F2: () => (this.currentSection = 1),
        F8: () => this.handlegetCallLocation(),
        F9: () => this.handleSubmitForms(),
        // F8: () => this.handleEnterKey({ shiftKey: true }),
      };

      if (keyActions[e.key] && this.selectItemFormList) {
        e.preventDefault();
        keyActions[e.key]();
      }
    },
    handleSubmitForms() {
      if (this.suggestCodeModal && this.selectItemFormList) {
        this.sendTo800FromSuggestModal();
        return;
      }

      if (!this.isFinalize) {
        this.showSuggestCodeModal();
      } else if (this.isFinalize) {
        this.checkForFinalizeMission(this.selectedQuestions, this.selectedAnswers);
      }
    },
    handlegetCallLocation() {
      if (this.type !== 'hand') {
        this.getCallLocation(this.uniqueId)
        return;
      }
    }
  },
  computed: {
    dndTimeNewCall() {
      return this.$root?.$refs?.Home?.dndTime || '';
    },
    isMainDNDNewCall() {
      return this.$root?.$refs?.Home?.isMainDND || false;
    },
    onlineMissionFilterList() {
      if (!this.onlineMissionList) return
      return this.onlineMissionList?.filter((u) => {
        return (
          u?.address?.includes(this.searchCurrentMission) ||
          u?.phoneNumber?.includes(this.searchCurrentMission) ||
          u?.chiefComplaintTitle?.includes(this.searchCurrentMission) ||
          u?.code?.includes(this.searchCurrentMission)
        );
      });
    },
    attachmentCurrentMissionFilterList() {
      return this.allAttachment.filter((u) => {
        return (
          u?.address?.includes(this.searchCurrentMission) ||
          u?.chiefComplaintTitle?.includes(this.searchCurrentMission) ||
          u?.code?.includes(this.searchCurrentMission)
        );
      });
    },
    attachallFilterList() {
      const list = [...this.allAttachment];
      let result = list;

      if (this.searchTextCode_Attach && this.searchTextCode_Attach.trim() !== '') {
        const searchLower = this.searchTextCode_Attach.toLowerCase().trim();
        result = result.filter((u) => {
          return (u?.code?.toLowerCase()?.includes(searchLower));
        });
      }

      return result;
    }
  },
};
</script>

<style scoped lang="scss">
.listContainer {
  position: relative;
  border-radius: 10px;
  display: flex;
  margin-top: 10px;

  .p1 {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-darkColor-base);
    position: absolute;
    top: -10px;
    right: 10px;
    background-color: white;
    z-index: 10000000;
  }
}

.searchMenuCard {
  position: relative;
  border-radius: 4px !important;
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  margin-top: 15px;

  &:hover {
    border-color: rgba(0, 0, 0, 0.87) !important;
  }

  .menu-label {
    position: absolute;
    top: -8px;
    right: 12px;
    background: white;
    padding: 0 6px;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.6);
    z-index: 1;
    font-family: 'Yekan-Bakh-Regular' !important;
  }
}

.moveOutsideRight {
  position: absolute;
  right: 101%;
}

.app-top-menu {
  position: sticky;
  top: 40px;
  background-color: white;
  z-index: 1001;
}

.new-call-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.current-mission-table {
  .v-data-table-headerbgz {
    position: sticky !important;
    top: 0 !important;
    background-color: white !important;
  }
}

.styleAddressOnMap {
  background: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 13px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 0 10px 10px #d3d3d3;

  p {
    font-size: 14px;
    font-weight: 400;
    color: gray;
    margin: 0 !important;
  }
}

.boxMainContent {
  height: 100%;
  max-height: calc(100% - 36px);

  .mdi-18px.mdi-set,
  .mdi-18px.mdi:before {
    font-size: 16px !important;
  }

  .v-input__icon {
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
    min-height: 20px !important;
  }
}

.midele {
  flex: 1;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-inline: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 4px;
  border: 1px solid #ededed;
  border-radius: 10px;
}

.topTitleBox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-right: 0.5rem;
  margin-left: 2px;
  margin-right: 2px;
  position: relative;
  overflow: hidden;

  .flexNone {
    flex: none;
    z-index: 10;
  }

  .divider {
    flex: 1 1 auto;
    width: 100%;
    position: absolute;
    right: 77px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-color: var(--v-primary-lighten4);
  }

  .txt1_style {
    min-width: 1.5rem;
    text-align: center;
    font-size: 0.75rem;
    margin-left: 0.5rem;
    position: relative;
    top: 1.5px;
  }

  .txt2_style {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-info-darken4);
  }
}

.mainBoxItem {
  &>div {
    padding: 6px 4px !important;
  }

  .btnAddCodeForMission {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
}

.new_call {
  &-container {
    position: relative;
  }

  &-footer {
    position: sticky;
    bottom: 0;
  }
}

header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: white;

  // .full-width-btn-group {
  //   width: 50%;
  //   border-radius: 10px;
  // }
  .active-button {
    background-color: var(--v-darkColor-base) !important;
    color: white !important;
  }

  .btn {
    color: var(--v-darkColor-base) !important;
    position: relative;
    background-color: #e8e8e8 !important;
    opacity: 0.8;
  }
}

.triage_container {
  margin: 0 !important;

  &>.col {
    display: flex;
    flex-direction: column;
    margin: 0 !important;

    &>.row {
      flex-grow: 0 !important;
    }

    &>.container {
      flex-grow: 1 !important;
    }
  }

  &-questions,
  &-answers {
    display: flex;
    position: relative;
    padding: 1rem;
    border: 1px solid var(--v-background-darken3);

    &>.col {
      &:first-of-type {
        position: sticky;
        top: -16px;
        left: 0;
        background-color: white;
        z-index: 10;
      }
    }

    &-header {
      color: var(--v-darkColor-base);

      div:last-child {
        background-color: var(--v-darkColor-base);
      }
    }

    .no-data {
      position: absolute;
      top: 50%;
    }

    .v-input__slot {
      align-items: stretch !important;
    }
  }

  &-answers {
    &-body {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  &-chips_container {
    min-height: 2rem;

    &-chip_item {
      font-size: 12px !important;
      border: 1px solid var(--v-darkColor-base) !important;
      color: #212121 !important;
      background-color: white !important;
      padding: 0 10px !important;
    }

    &-active_chip {
      border: 1px solid var(--v-darkColor-base) !important;
      color: white !important;
      background-color: var(--v-darkColor-base) !important;
    }
  }

  &-empty_algorithem-container {
    height: 40px;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    padding: 0 1rem;

    p {
      font-size: 12px;
      font-weight: 500;
      color: var(--v-secondary-base);
      border: 1px solid var(--v-background-darken3);
      border-radius: 12px;
      padding: 5px 15px;
      flex-shrink: 0;
      flex-grow: 0;
      margin: 0 !important;
    }

    span {
      flex-shrink: 1;
      flex-grow: 1;
      flex: 1;
      height: 1px;
      background: var(--v-background-darken3);
    }
  }
}

.triage_algorithemList {
  width: 100%;
  max-width: calc(100% - 50px);
  flex: 0 0 calc(100% - 50px);
}

.triage_chip_Selectitem {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .divider {
    width: 25px;
    height: 1px;
    background: var(--v-darkColor-lighten5);
    position: relative;

    &::after {
      content: '◆';
      position: absolute;
      left: -7px;
      top: 4px;
      color: var(--v-darkColor-lighten4);
      font-size: 14px;
      z-index: 10;
      line-height: 0;
    }

    &::before {
      content: '●';
      position: absolute;
      right: -6px;
      top: 2px;
      color: var(--v-darkColor-lighten4);
      font-size: 15px;
      z-index: 10;
      line-height: 0;
    }
  }
}

.triage_answers_container {
  display: flex;
  border: 1px solid var(--v-background-darken3);
  padding: 1rem;
  height: 12vh;
  min-height: 130px;
  max-height: 300px;
  margin-top: 9px;

  &-title {
    color: var(--v-secondary-base);
  }
}

.modal-title-text {
  display: block;
  margin-left: 5rem;
  font-size: 1rem;
  color: var(--v-darkColor-base);
}

.img-box {
  padding: 0.5rem;
  border: 1px dashed #79747e;
  border-radius: 0.5rem;
  cursor: pointer;

  .selected-img {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
  }
}

.btnAttachment {
  border: 1px solid var(--v-background-darken3);
  border-radius: 50%;
  transform: rotate(-90deg);
}

.btnsFootr {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 11px;
  padding: 10px 20px;

  &.itemRightBtnsFootr {
    >button {
      min-width: 120px;
      max-width: 120px;
      height: 36px;
    }
  }

  &.itemLeftBtnsFootr {
    >div {
      min-width: 180px;
    }
  }
}

.customShadow {
  box-shadow: 0px 2px 8px 0px #30529c5c;
}

.custombtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  margin: auto;
  margin-top: 5px;
}

.boxTabSelect {
  flex: none;
  width: 20px;
  height: 100%;
  position: relative;

  .absolute-wrapper {
    position: absolute;
    left: -113px;
    top: 0;
    width: max-content;
    height: max-content;
    transform: translateY(100%);
  }

  .rotated-wrapper {
    transform: rotate(-90deg) translateX(-32%);
    width: max-content;
    height: max-content;
  }

  .custom-v-tabs {
    transform: translateX(-50%) translateY(calc(-30%));
  }

  .tabCustom {
    text-align: left;
    margin-bottom: 8px;
    border-radius: 5px;
    font-size: 13.5px !important;
    font-weight: 400 !important;
    min-width: 90px !important;
    padding: 0 10px !important;
  }

  .counterSpan {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    background-color: #dedede;
    color: #777777;
    border-radius: 50%;
    margin-right: 4px;

    &.hasNumber {
      background-color: red;
      color: white;
      animation: pulseGlow 1.5s infinite;
    }

    .s1 {
      position: relative;
      left: 1px;
      font-size: 11px;
      line-height: 1;
    }
  }

  .darkColor.white--text {
    background-color: var(--v-darkColor-base);
    color: white !important;
  }
}

@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 0 0 rgba(133, 0, 0, 0.29);
  }

  70% {
    box-shadow: 0 0 0 5px rgba(255, 0, 0, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

.hasBTS {
  animation: pulseGlow 2.2s infinite;
}
</style>


<style scoped>
.custom-label {
  font-size: 11px;
}

/* خط جداکننده بین تب‌ها */
.custom-tabs-with-divider ::v-deep .v-tab:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background-color: #e0e0e0;
}

>>>.v-tabs-bar {
  height: 36px !important;
}

>>>.v-label {
  font-size: 11px !important;
  font-family: 'Yekan-Bakh-Regular' !important;
}

>>>.v-text-field.v-input--dense .v-label {
  top: 9px !important;
}

>>>.v-text-field--outlined.v-input--dense .v-label--active {
  /* right: -18px !important; */
  padding-right: 4px !important;
  font-size: 14px !important;
}

>>>.v-text-field .v-input__slot {
  padding-inline: 9px !important;
}

>>>.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
  min-height: 38px !important;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
  height: 7vh !important;
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
  margin-left: 0 !important;
}

.action-part {
  background: var(--background-color) !important;
}

.question-card {
  background: white !important;
  border-top: 2px solid #ebebeb !important;
  border-bottom: 2px solid #ebebeb !important;
  border-left: 3px solid #212121 !important;
  border-right: 3px solid #212121 !important;
  border-radius: 10px !important;
}

.current-missions-card {
  border: 1px solid #212121 !important;
  border-radius: 10px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-top-items {
  cursor: pointer !important;
  font-weight: 600;
}

>>>.mdi-18px.mdi-set,
>>>.mdi-18px.mdi:before {
  font-size: 16px !important;
}

>>>.v-input__icon {
  width: 17px !important;
  min-width: 17px !important;
}

>>>.v-chip.v-size--small {
  font-size: 9px !important;
  height: 26px !important;
  padding-left: 3px !important;
  padding-right: 3px !important;
  border-radius: 12px !important;
}

.selectCodeBox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  background: var(--background-color) !important;
  border-radius: 5px !important;
  overflow-y: auto;
  overflow-x: hidden;
  height: 44px;
  margin-right: auto;
  /* max-width: calc(50% - 5px) !important; */
  flex: 1;
}

.selectedCode {
  background: white !important;
  padding-left: 7px !important;
  padding-right: 7px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}

.general-triage-question {
  margin-top: 0px !important;
}

.general-triage-question-text {
  color: #212121 !important;
  font-size: 14px !important;
  letter-spacing: normal !important;
}

.triage-chips {
  font-size: 12px !important;
  color: black !important;
  border-width: 3px !important;
}

.go-to-triage-text-style {
  font-size: 12px !important;
}

>>>.current-mission tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}

>>>.history-mission tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}

.triage-map-tag-text {
  font-size: 10px !important;
  cursor: pointer;
}

.general-triage-map-part {
  border-radius: 8px !important;
  background: #f3f3f3 !important;
}

.general-triage-title {
  font-weight: 500;
  white-space: nowrap;
  font-size: 12px;
}

.time-passed {
  margin-top: 1px !important;
  color: var(--dark-color) !important;
  margin-right: 5px !important;
}

.main-number {
  margin-top: 1px !important;
  color: var(--dark-color) !important;
  margin-right: 5px !important;
}

.rank-icon-anim1 {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

.rank-icon-anim2 {
  animation: shake2 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes shake2 {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(5deg);
  }

  50% {
    transform: rotate(0eg);
  }

  75% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.Vue-Toastification__container {
  z-index: 9999999999999999999999999999999 !important;
}

.calltag-items {
  cursor: pointer !important;
}

.address-part {
  width: 95%;
  min-width: 95%;
  max-width: 95%;
}

.address-check-part {
  width: 5%;
  min-width: 5%;
  max-width: 5%;
}

.rank-space-modal-header {
  width: 12%;
  min-width: 12%;
  max-width: 12%;
}

.rank-space-modal-header-blank {
  width: 8%;
  min-width: 8%;
  max-width: 8%;
}

.menu-space-modal-header {
  width: 50%;
  min-width: 50%;
  max-width: 50%;
}

>>>.sugest-input fieldset {
  background: white !important;
}

>>>.sugest-input .v-input__prepend-inner {
  z-index: 2;
}

>>>.search-map-input fieldset {
  background: white !important;
}

>>>.search-map-input .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.search-map-input.v-input input {
  max-height: 30px !important;
}

>>>.latlng-map-input fieldset {
  background: white !important;
}

>>>.latlng-map-input .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.latlng-map-input.v-input input {
  max-height: 30px !important;
}

.latlng-map-input {
  width: 350px;
  min-width: 350px;
  max-width: 350px;
}

.triage-card {
  background: var(--background-color) !important;
}

.show-triage-balini-modal-icon {
  padding: 5px !important;
  /* background: var(--v-darkColor-base) !important; */
  border-radius: 50% !important;
  border: 1px solid var(--v-darkColor-base);
  background: white;
  transition: all 0.3s ease-in-out;
}

.show-triage-balini-modal-icon:hover {
  background: #e4e0ff;
}

.triage-advice-title-part {
  width: 10%;
  min-width: 10%;
  max-width: 10%;
}

.triage-advice-text-part {
  width: 90%;
  min-width: 90%;
  max-width: 90%;
}

.ravan-part {
  width: 22%;
  min-width: 22%;
  max-width: 22%;
}

.header-back-0 {
  background: #f4f4f4 !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.header-back-1 {
  background: #a4ffcb !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.header-back-2 {
  background: #ffe290 !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.header-back-3 {
  background: #ffafaf !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.header-back {
  background: white !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.sroll-triage-card {
  overflow-y: auto !important;
}

.trige-map-change-cheif-complaint {
  font-size: 11px;
  font-weight: bold;
}

.searchMenu {
  animation-duration: 0.3s !important;
}

.search-field-container {
  max-width: 65% !important;
  width: 65% !important;
  flex: 1 1 auto;
}

.search-height-transition-enter-active,
.search-height-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.search-height-transition-enter,
.search-height-transition-leave-to {
  max-height: 0 !important;
  opacity: 0;
  transform: translateY(-5px);
}

.search-height-transition-enter-to,
.search-height-transition-leave {
  max-height: 200px !important;
  opacity: 1;
  transform: translateY(0);
}

.search-list {
  overflow-y: auto;
}



.location-title {
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.location-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  min-height: 56px;
  width: 100% !important;
  max-width: 100% !important;
  transition: all 0.2s ease;
}

.location-list-item:hover {
  background-color: #f3f4f6;
}
</style>
